import { z } from 'zod';
export const ClipboardSync = z.object({
    direction: z.enum(['host->client', 'client->host']),
    text: z.string().max(200_000),
});
//# sourceMappingURL=clipboard.js.map